import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import emptyImg from 'assets/icons/empty.svg';

function NoData({ message }: { message?: string }) {
	const { t } = useTranslation();

	return (
		<Empty
			image={<img className="d-block m-auto mb-4 " src={emptyImg} />}
			description={<p className="fw-medium">{message || t('COMMON.NO_DATA')}</p>}
		/>
	);
}

export default NoData;
